import React from "react";
import Maincontent from "./Maincontent";
import Testimonial from "./Testimonial";
import WhyChoose from "./Whychoose";
import Popularclass from "./Popularclass";
import Chef from "./Chef";
export default function Home(){
    return(
        <>
        <Maincontent/>
         <Popularclass/>
   <Testimonial/>
        <WhyChoose/>
       
        <Chef/>
        
        </>
    )
}